import React from 'react';
import './_nagpixelsearch.scss'
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Alert from '../../react/components/base/alert/Alert';


class NAGPixelSearch extends React.Component {
    static propTypes = {
      creative_preview: PropTypes.any,
      partner: PropTypes.any
    }

    constructor(props) {
      super(props);
      this.state = {
        inputText: '',
        initialPixelKey: new URL(window.location.href).searchParams.get('pixel_key'),
      };
    }

    onChange(e) {
      this.setState({ inputText: e.target.value });
    }

    handleSearch = () => {
        let searchKey;
        try {
            const inputUrl = new URL(this.state.inputText);
            searchKey = inputUrl.searchParams.get('key');
        } catch {
            searchKey = this.state.inputText
        }
        window.location.href = `/rtb_pixels/search?pixel_key=${searchKey}`;
    }


    render() {
      let demoLink = '';

      if (this.props.creative_preview) {
        demoLink = this.props.partner ?
          `https://${this.props.partner.subdomain}.nativeadvertising.com/share/${this.props.creative_preview.id}` :
          `/share/${this.props.creative_preview.id}`;
      }

      return (
        <div className="nag-pixel-search container mt5">
          <h1>NAG demo grabber</h1>
          <form className='nag-search-form'>
            <label htmlFor="nagPixel">Input NAG Pixel</label>
            <TextField className="mb2 mt2" placeholder="e.g. https://b.sharethrough.com/native_display?key=vqvNr6Uk64LeJZXnUWMbaXN6" required size="small" variant="outlined" onChange={e => this.onChange(e)} name="nagPixel" />
            <button
              className="mb2 btn btn-secondary"
              type="button"
              onClick={this.handleSearch}
              data-testid="search-button"
            >
              Search
            </button>
            {!this.props.creative_preview && (this.state.initialPixelKey || this.state.initialPixelKey === '') && (
              <Alert severity="danger">
                <div data-testid="error-alert-message">
                  <h5>Error</h5>
                  There is no creative associated to this pixel.
                </div>
              </Alert>
            )}
            {this.props.creative_preview && (
              <Alert severity="success">
                <div data-testid="success-alert-message">
                  <h5>Creative was found!</h5>
                  You can access the demo <a data-testid="demo-link" href={demoLink}>HERE</a>
                </div>
              </Alert>
            )}
          </form>
        </div>
      );
    }
}

window.NAGPixelSearch = NAGPixelSearch;

export default NAGPixelSearch;
